import IStepOneModel from './IStepOneModel';

const StepOneModelInitialState: IStepOneModel = {
  cityMoredBimehCoreId: null,
  provinceMoredBimehCoreId: null,
  noeFaaliatCoreId: null,
  noeSazehCoreId: null,
  senSakhteman: null,
  isInCity: true,
};

export default StepOneModelInitialState;
